import { c as _c } from "react/compiler-runtime";
import { LoaderWithContainer } from '@winelidays/wld-tsx-2/elements';
import { lazy } from 'react';
import useReviews from '../../context/useReviews';
import useReviewsEntity from '../../context/useReviewsEntity';
const Review = lazy(() => import('./Review'));
const NoReviewsWithFilters = lazy(() => import('./NoReviewsWithFilters'));
const ReviewList = () => {
    const $ = _c(4);
    const { reviews, loadingReviews } = useReviews();
    const entity = useReviewsEntity();
    let t0;
    if ($[0] !== entity || $[1] !== loadingReviews || $[2] !== reviews) {
        t0 = loadingReviews ? <LoaderWithContainer className="h-72"/> : reviews && reviews.length ? <ul className="border-b border-gray-100 last:border-b-0">{reviews.map(review => <Review key={review.id} review={review} bookable={entity}/>)}</ul> : <NoReviewsWithFilters />;
        $[0] = entity;
        $[1] = loadingReviews;
        $[2] = reviews;
        $[3] = t0;
    }
    else {
        t0 = $[3];
    }
    return t0;
};
export default ReviewList;
